var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoToastSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#9B51E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7474 7.66436C15.1143 7.25158 15.0771 6.61951 14.6644 6.25259C14.2516 5.88567 13.6195 5.92285 13.2526 6.33564L14.7474 7.66436ZM8.66667 13L7.8858 13.6247C8.06989 13.8548 8.34612 13.992 8.64072 13.9997C8.93532 14.0073 9.21829 13.8846 9.41408 13.6644L8.66667 13ZM6.78087 9.04197C6.43586 8.61071 5.80657 8.54079 5.3753 8.8858C4.94404 9.23081 4.87412 9.8601 5.21913 10.2914L6.78087 9.04197ZM13.2526 6.33564L7.91926 12.3356L9.41408 13.6644L14.7474 7.66436L13.2526 6.33564ZM9.44754 12.3753L6.78087 9.04197L5.21913 10.2914L7.8858 13.6247L9.44754 12.3753Z",
    fill: "#9B51E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoToastSuccess);
export default __webpack_public_path__ + "static/media/ico-toast-success.50982dfa58a14bd5ffdcea5abf2b0264.svg";
export { ForwardRef as ReactComponent };